import ClientVehicleTypes from "./components/ClientVehicleTypes/ClientVehicleTypes"

export const ScreenTypes = {
    ASSET_TYPE: 11
}

export const screenTypeAdditionalComponent = (clientAccountId) => ({
    [ScreenTypes.ASSET_TYPE]: <ClientVehicleTypes clientAccountId={clientAccountId} />
})